import React, { useEffect, useState } from 'react';

import SendInvite from '../../components/sendInvite/SendInvite';
import User from '../../models/User';
import useBlocRef from '../../utils/useBlocRef.hook';

const inviteFields = [
  { label: 'Administrator Name', name: 'name', placeholder: 'Administrator Name', required: true, type: 'text' },
  { label: 'Telephone', name: 'phoneNumber', placeholder: '+27828501512', required: true, type: 'phone' },
  { label: 'Administrator Email Address', name: 'email', placeholder: 'email@address.com', required: true, type: 'text' },
];

export default ({ workspaceId, onUpdateAdmins }) => {
  const blocRef = useBlocRef('resendInviteBloc');
  const [admin, setAdmin] = useState(new User());

  useEffect(() => {
    const sub = blocRef.current.adminToInvite$.subscribe(setAdmin);
    return () => sub.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onInvite = async ({ name, phoneNumber, email }) => {
    await blocRef.current.reInviteAdmin(name, phoneNumber, email, admin.id, workspaceId);
    onUpdateAdmins();
  };

  return (
    <SendInvite
      fields={inviteFields}
      buttonText="Resend Invite"
      onInvite={onInvite}
      user={admin}
      title="Resend Invite"
      hint="If a user has not accepted or accessed their account you can resend the invite from this screen."
      note="Note that an invitation link will be sent to the administrator email address once the workspace is created"
      isSubmitting$={blocRef.isReInvitingAdmin$}
    />
  );
};
